// src/pages/auth/Login.jsx
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { login, translateAuthError } from "../../lib/auth";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  async function submit(e) {
    e.preventDefault();
    setErr(null);
    setLoading(true);

    try {
      await login(email, password);

      const fbUser = auth.currentUser;
      if (!fbUser) {
        navigate(from, { replace: true });
        return;
      }

      const userRef = doc(db, "users", fbUser.uid);
      const snap = await getDoc(userRef);

      let role = "";
      let isVendorFlag = false;
      let vendorId = "";
      let vendorName = "";

      if (snap.exists()) {
        const data = snap.data() || {};
        role = String(data.role || "").toLowerCase();
        isVendorFlag = Boolean(data.isVendor);

        // ✅ le plus important
        vendorId = String(data.vendorId || "").trim();
        vendorName = String(data.vendorName || data.shopName || "").trim();
      }

      const isVendor = isVendorFlag || role === "vendor";
      const isAdmin = role === "admin" || role === "superadmin";

      if (isVendor) {
        // ✅ fallback: si tu n’as pas encore vendorId dans users
        const resolvedVendorId = vendorId || fbUser.uid;

        localStorage.setItem("vendorId", resolvedVendorId);
        if (vendorName) localStorage.setItem("vendorName", vendorName);
        localStorage.setItem("role", "vendor");

        navigate("/vendor/dashboard", { replace: true });
        return;
      }

      if (isAdmin) {
        localStorage.setItem("role", "admin");
        navigate("/admin/dashboard", { replace: true });
        return;
      }

      navigate(from, { replace: true });
    } catch (e) {
      console.error(e);
      setErr(translateAuthError(e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="row justify-content-center">
      <div className="col-md-6 col-lg-5">
        <div className="card-modern p-4">
          <h3 className="mb-3">Connexion</h3>
          <p className="text-muted small mb-3">
            Espace réservé aux vendeurs et administrateurs.
          </p>

          {err && <div className="alert alert-danger py-2">{err}</div>}

          <form onSubmit={submit} className="row g-3">
            <div className="col-12">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            <div className="col-12">
              <label className="form-label">Mot de passe</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            <div className="col-12 d-flex justify-content-between align-items-center mt-2">
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? "Connexion…" : "Se connecter"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
